import type { Pinia } from '@pinia/nuxt/dist/runtime/composables'

export default defineNuxtPlugin(async (nuxtApp) => {
  const { $pinia } = nuxtApp
  const { fetchInitialData } = useRootStore($pinia as Pinia)
  await fetchInitialData()
})
